import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ProfessionProps } from "../types/attribute/profession";
import { api } from "../services/api.service";

export const fetchProfessions = createAsyncThunk<ProfessionProps[]>(
  "fetch/professions",
  async () => {
    const data = await api.attribute.profession.getAll();
    return data as ProfessionProps[];
  }
);

interface professionsState {
  professions: ProfessionProps[];
  profession: null | ProfessionProps;
  loading: boolean;
  error: null | string;
}

const initialState: professionsState = {
  professions: [],
  profession: null,
  loading: false,
  error: null,
};

export const professionsSlice = createSlice({
  name: "professions",
  initialState,
  reducers: {
    addProfession: (state, action: PayloadAction<ProfessionProps>) => {
      state.professions.push(action.payload);
    },
    removeProfession: (state, action: PayloadAction<{ id: number }>) => {
      state.professions = state.professions.filter(
        (profession) => profession.id !== action.payload.id
      );
    },
    updateProfession: (state, action: PayloadAction<ProfessionProps>) => {
      state.professions = state.professions.map((profession) =>
        profession.id === action.payload.id ? action.payload : profession
      );
    },
  },
  extraReducers(builder) {
    builder
      .addCase(fetchProfessions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchProfessions.fulfilled, (state, action) => {
        state.error = null;
        state.loading = false;
        state.professions = action.payload;
      })
      .addCase(fetchProfessions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Something went wrong";
      });
  },
});

export const { addProfession, removeProfession, updateProfession } =
  professionsSlice.actions;

export default professionsSlice.reducer;
